var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIlluminance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C10.6 4 11 3.60004 11 3V1C11 0.399964 10.6 0 10 0C9.39996 0 9 0.399964 9 1V3C9 3.60004 9.39996 4 10 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C9.39996 16 9 16.4 9 17V19C9 19.6 9.39996 20 10 20C10.6 20 11 19.6 11 19V17C11 16.4 10.6 16 10 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6999 5.80001L17.0999 4.40004C17.4999 4.00008 17.4999 3.40004 17.0999 3.00008C16.6999 2.60011 16.0999 2.60011 15.6999 3.00008L14.3 4.40004C13.9 4.80001 13.9 5.40004 14.3 5.80001C14.6999 6.20011 15.2998 6.10009 15.6999 5.80001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29955 14.2L2.89958 15.6C2.49962 15.9999 2.49962 16.6 2.89958 16.9999C3.29955 17.3999 3.89958 17.3999 4.29955 16.9999L5.69951 15.6C6.09948 15.2 6.09948 14.6 5.69951 14.2C5.29955 13.7999 4.69965 13.8999 4.29955 14.2Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9H17C16.4 9 16 9.39996 16 10C16 10.6 16.4 11 17 11H19C19.6 11 20 10.6 20 10C20 9.39996 19.6 9 19 9Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 9.39996 3.60004 9 3 9H1C0.399964 9 0 9.39996 0 10C0 10.6 0.399964 11 1 11H3C3.60004 11 4 10.6 4 10Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6999 14.2C15.3 13.8 14.6999 13.8 14.3 14.2C13.9 14.6 13.9 15.2 14.3 15.6L15.6999 16.9999C16.0999 17.3999 16.6999 17.3999 17.0999 16.9999C17.4999 16.6 17.4999 15.9999 17.0999 15.6L15.6999 14.2Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29955 5.8C4.69951 6.19997 5.29955 6.19997 5.69951 5.8C6.09948 5.40004 6.09948 4.8 5.69951 4.40004L4.29955 2.90004C3.89958 2.50008 3.29955 2.50008 2.89958 2.90004C2.49962 3.3 2.49962 3.90004 2.89958 4.3L4.29955 5.8Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C7.20007 5 5 7.20007 5 10C5 12.7999 7.20007 15 10 15C12.7999 15 15 12.7999 15 10C15 7.20007 12.7999 5 10 5ZM10 13C8.29993 13 7 11.7001 7 10C7 8.29993 8.29993 7 10 7C11.7001 7 13 8.29993 13 10C13 11.7001 11.7001 13 10 13Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluminance);
export default __webpack_public_path__ + "static/media/illuminance.213c61cc3334628bd9665e8f363ab89a.svg";
export { ForwardRef as ReactComponent };